<template>
    <Dialog :visible="visible" @update:visible="updateVisible" header="Selecionar Contrato" @show="onShow" @hide="onHide"
        class="w-11 lg:w-8" modal>
        <div>
            <div>
                <div>
                    <form @submit.prevent="onSubmitBusca">
                        <Toolbar class="bg-gray-100 w-full">
                            <template #start>
                                <div>
                                    <InputGroup>
                                        <InputGroupAddon>ID Primário e Secundário</InputGroupAddon>
                                        <InputText class="w-full" v-model="params.filter.contrato" autofocus />
                                    </InputGroup>
                                </div>
                            </template>
                            <template #end>
                                <div class="flex gap-1">
                                    <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                                        class="p-button-sm" />
                                    <Button icon="pi pi-eraser" label="Limpar" severity="danger" size="small"
                                        class="p-button-sm" @click="onClearBusca" />
                                    <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small"
                                        class="p-button-sm" @click="loadData" />
                                </div>
                            </template>
                        </Toolbar>
                    </form>

                    <DataTable :value="lista" :loading="isLoading" v-model:selection="selected" selectionMode="single"
                        size="small" stripedRows showGridlines @row-dblclick="onDbClick" scrollable
                        scrollHeight="calc(100vh - 400px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                        @sort="onTableSort">

                        <Column style="width: 100px" field="id" header="#" sortable></Column>
                    <Column field="id_primario" header="ID Primario" sortable></Column>
                    <Column field="id_secundario" header="ID Secundario" sortable></Column>
                    <Column field="solicitante" header="Solicitante" sortable></Column>
                    <Column field="cliente" header="Cliente" sortable></Column>
                    <Column field="provedor" header="Provedor" sortable></Column>
                    <Column field="site" header="Site/Localidade" sortable></Column>

                    <template #empty>
                        <div class="text-center text-gray-600">
                            Nenhum registro encontrado
                        </div>
                    </template>
                    </DataTable>
                    <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                        @page="onPage">
                    </Paginator>
                </div>
            </div>

            <div class="flex justify-content-end gap-1">
                <Button label="Selecionar" severity="success" icon="pi pi-check-circle" size="small" @click="selecionar"
                    :disabled="!selected" class="flex align-items-center justify-content-center" />
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" />
            </div>
        </div>
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import Card from 'primevue/card';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';
import ScrollPanel from 'primevue/scrollpanel';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';

import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';

import Contrato from '@/service/contrato.js';


import Mask from '@/utils/Mask.js';
import Filter from '@/utils/Filter.js';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        permissoes: {},
    },
    emits: ['select', 'close'],
    components: {
        Dialog,
        Card,
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,
        ScrollPanel,
        InputGroup,
        InputGroupAddon,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,


    },
    data() {
        return {
            lista: [],
            isLoading: false,

            selected: null,

            item: null,
            visibleForm: false,

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: 1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
        }
    },
    methods: {
        openForm() {
            this.item = { };
            this.visibleForm = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
        },

        onDbClick(event) {
            this.selected = event.data;
            this.$emit('select', event.data);
            this.$emit('close');
        },
        onShow() {
            this.loadData();
        },
        onHide() {
            this.selected = null;
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        selecionar() {
            if (this.selected) {
                this.$emit('select', this.selected);
                this.$emit('close');
            }
        },
        limpar() {
            this.$emit('select', null);
            this.$emit('close');
        },
        loadDataParams() {
            let params = ['completo=1'];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Contrato.vigente(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        onClearBusca(event) {
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.onPage();
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        }
    }
}
</script>
